import { Action } from "../../actions/types";
import { PRODUCT_QR_CODE_CHANNEL, QR_CODE_CHANNEL } from "../../constants";
import { Referral } from "./index";

export const initialState = {};
type StoreState = Referral | {};

export function reducer(
  state: StoreState = initialState,
  action: Action
): StoreState {
  if (
    action.type === "GET_REFERRAL_SUCCESS" &&
    action.data &&
    (action.data.channel === QR_CODE_CHANNEL ||
      action.data.channel === PRODUCT_QR_CODE_CHANNEL)
  ) {
    return { ...state, ...action.response.data };
  }

  return state;
}
